import CheckPermission from 'components/common/CheckPermissions';
import React from 'react';
import { Link } from 'react-router-dom';
import { PERMISSION_KEY } from 'configs/localData';
import CustomCentreNameFallback from './CustomCentreNameFallback';

const CustomCentreName = ({ record }) => {
  const { centreId, centreName } = record?.centre || record;

  return (
    <CheckPermission
      permissionKey={PERMISSION_KEY.contacts}
      action="isView"
      packageName={record?.subscription?.name}
      fallback={
        <CustomCentreNameFallback
          currentCentreId={centreId}
          centreName={centreName}
          isBlur={record?.isBlur}
        />
      }
    >
      <Link className="text-black" to={`/centres/${centreId}/show/summary`}>
        {centreName}
      </Link>
    </CheckPermission>
  );
};

export default CustomCentreName;
